const e = "Svuota il campo di ricerca", c = "Seleziona opzione", a = {
  clearSearch: e,
  selectPlaceholder: c,
  "Select.InputSearch.Value:placeholder": "Ricerca",
  "Select.InputSearch.Value:aria-label": "Ricerca"
};
export {
  e as clearSearch,
  a as default,
  c as selectPlaceholder
};
